import { IncomeBasis } from "./enums";
import dependencyMap from "./fieldDependencyMap";
import validatorMap from "./fieldValidatorMap";
export const checkCustomValidity = (field, isSubmitOrDependency = false, name) => {
    const disabledAncestor = field.closest("[disabled]");
    if (disabledAncestor !== null) {
        field.setCustomValidity("");
        return;
    }
    const fieldName = name || field.name;
    const shouldValidate = field.required ||
        (field.type !== "number" && field.value.length > 0) ||
        (field.type === "number" &&
            parseInt(field.value) > 0);
    if (shouldValidate) {
        const validator = validatorMap[fieldName];
        if (!validator) {
            return;
        }
        field.setCustomValidity(validator(field));
        if (!isSubmitOrDependency) {
            field.reportValidity();
        }
    }
};
export const getValidateFieldNames = () => {
    const names = Object.keys(validatorMap);
    for (const key in dependencyMap) {
        if (!names.includes(key)) {
            names.push(key);
        }
    }
    return names;
};
export const getIncomeMaxValue = (basis) => {
    switch (basis) {
        case IncomeBasis.Annually:
            return 99999999;
        case IncomeBasis.Monthly:
            return 8333333;
        case IncomeBasis.Biweekly:
            return 3846153;
        case IncomeBasis.Weekly:
            return 1923076;
        default:
            return 0;
    }
};
export const makeFieldsRequired = (form, fields) => {
    for (const fieldName of fields) {
        const field = form[fieldName];
        field.setAttribute("required", "true");
    }
};
export const makeFieldsNotRequired = (form, fields) => {
    for (const fieldName of fields) {
        const field = form[fieldName];
        field.removeAttribute("required");
    }
};
export const showHideAdditionalIncome = (box) => {
    const section = document.getElementById(box.getAttribute("data-add-income-section-id"));
    if (!section)
        return;
    const controls = section.querySelectorAll("input, select, textarea");
    if (box.checked) {
        section.removeAttribute("hidden");
        section.removeAttribute("disabled");
        for (const c of controls) {
            c.removeAttribute("disabled");
            if (c.hasAttribute("data-ai-required")) {
                c.setAttribute("required", "true");
                c.removeAttribute("data-ai-required");
            }
        }
    }
    else {
        section.setAttribute("hidden", "true");
        section.setAttribute("disabled", "true");
        for (const c of controls) {
            if (c.hasAttribute("required"))
                c.setAttribute("data-ai-required", "1");
            c.setAttribute("disabled", "true");
            c.removeAttribute("required");
            c.setCustomValidity?.("");
        }
    }
};
export const updateDependents = (field) => {
    const disabledAncestor = field.closest("[disabled]");
    if (disabledAncestor !== null) {
        return true;
    }
    const settings = dependencyMap[field.name];
    if (!settings) {
        return true;
    }
    settings.updateHandler && settings.updateHandler(field);
    let dependentsValid = true;
    for (const dep of settings.fields) {
        const depField = field.form[dep];
        if (!depField) {
            console.error(`Form field with name ${dep} does not exist on GM Finance Form, but was listed as a dependent field for ${field.name}.`);
            continue;
        }
        checkCustomValidity(depField, true);
        if (dependentsValid && !depField.validity.valid) {
            dependentsValid = false;
        }
    }
    return dependentsValid;
};
export const updateIncomeField = (basis, incomeField) => {
    if (basis === "") {
        incomeField.value = "0";
        incomeField.max = "0";
        incomeField.setAttribute("disabled", "true");
    }
    else {
        incomeField.max = `${getIncomeMaxValue(basis)}`;
        incomeField.removeAttribute("disabled");
    }
};
